import React from 'react'
import { graphql } from 'gatsby'
import { Trans } from 'gatsby-plugin-react-i18next'
import { Seo } from '../components/SEO'
import ProductsHero from '../components/ProductsHero'
import SectionTextPictureImgFullH from '../components/SectionTextPictureImgFullH'
import SectionBacgkround from '../components/SectionBackground'
import TilesSwiper2 from '../components/TilesSwiper2'
import SectionOrder from '../components/SectionOrder'
import SelectedProducts from '../components/SelectedProducts'
import MHeroVideo from '../assets/video/mobile/mobile_KV17.mp4'
import THeroVideo from '../assets/video/tablet/tablet_KV17.mp4'
import DHeroVideo from '../assets/video/desktop/desktop_KV17.mp4'
import CsHeadShowcase from '../components/CSHeadShowcase'

import BG1 from '../assets/imgs/CSHead/BG1.jpg'
import BG2 from '../assets/imgs/CSHead/BG2.jpg'
import BG3 from '../assets/imgs/CSHead/BG3.jpg'
import BG4 from '../assets/imgs/CSHead/BG4.jpg'


import Icon1 from '../assets/svg/gimbal.inline.svg'
import Icon2 from '../assets/svg/polarization-filter.inline.svg'
import Icon3 from '../assets/svg/lens-hood.inline.svg'
import Icon4 from '../assets/svg/background-removal-interior.inline.svg'
import Icon5 from '../assets/svg/bg-removal-exterior-panorama.inline.svg'
import Icon6 from '../assets/svg/bg-remova.inline.svg'
import Icon7 from '../assets/svg/adjustable-height.inline.svg'
import Icon8 from '../assets/svg/scan-made-by-hand.inline.svg'
import Icon9 from '../assets/svg/easy-to-work-with.inline.svg'
import Icon10 from '../assets/svg/better-photos.inline.svg'
import Icon11 from '../assets/svg/close-ups.inline.svg'
import Icon12 from '../assets/svg/smartphone.inline.svg'
import Icon13 from '../assets/svg/tripod.inline.svg'
import Icon14 from '../assets/svg/charger.inline.svg'
import Icon15 from '../assets/svg/user-manual.inline.svg'


import Picture1 from '../assets/imgs/CSHead/KV18-01.webp'
import CSHeadSpherePreview from '../components/CSHeadSpherePreview'

const BGObject = [
    {
        name: 'BG1',
        img: BG1,
        alt: 'Blue KIA vehicle with generic background',
    },
    {
        name: 'BG2',
        img: BG4,
        alt: 'Blue KIA vehicle on generated turntable',
    },
    {
        name: 'BG3',
        img: BG3,
        alt: 'Vehicle generated on background containing concrete floor and fog',
    },
    {
        name: 'BG4',
        img: BG2,
        alt: 'Removed background behind the car',
    },
]

const SlideTiles1 = [
    {
        content: <Trans>SlideTilesContent1_1</Trans>,
        icon: <Icon1 />,
    },
    {
        content: <Trans>SlideTilesContent1_2</Trans>,
        icon: <Icon2 />,
    },
    {
        content: <Trans>SlideTilesContent1_3</Trans>,
        icon: <Icon3 />,
    },
    {
        content: <Trans>SlideTilesContent1_4</Trans>,
        icon: <Icon4 />,
    },
    {
        content: <Trans>SlideTilesContent1_5</Trans>,
        icon: <Icon5 />,
    },
    {
        content: <Trans>SlideTilesContent1_6</Trans>,
        icon: <Icon6 />,
    },
    {
        content: <Trans>SlideTilesContent1_7</Trans>,
        icon: <Icon7 />,
    },
]

const SlideTiles2 = [
    {
        content: <Trans>SlideTilesContent2_1</Trans>,
        icon: <Icon8 />,
    },
    {
        content: <Trans>SlideTilesContent2_2</Trans>,
        icon: <Icon9 />,
    },
    {
        content: <Trans>SlideTilesContent2_3</Trans>,
        icon: <Icon10 />,
    },
    {
        content: <Trans>SlideTilesContent2_4</Trans>,
        icon: <Icon11 />,
    },
]

const SlideTiles3 = [
    {
        content: <Trans>SlideTilesContent3_1</Trans>,
        icon: <Icon12 />,
    },
    {
        content: <Trans>SlideTilesContent3_2</Trans>,
        icon: <Icon13 />,
    },
    {
        content: <Trans>SlideTilesContent3_3</Trans>,
        icon: <Icon2 />,
    },
    {
        content: <Trans>SlideTilesContent3_4</Trans>,
        icon: <Icon3 />,
    },
    {
        content: <Trans>SlideTilesContent3_5</Trans>,
        icon: <Icon14 />,
    },
    {
        content: <Trans>SlideTilesContent3_6</Trans>,
        icon: <Icon15 />
    },
]


const csHead = () => {
    return (
        <>
            <ProductsHero
                id='CSHeadHero'
                whereToScroll='csgimbalspherepreview'
                title={<Trans>ProductsHeroTitle</Trans>}
                heading={<Trans>ProductsHeroHeading</Trans>}
                description={<Trans>ProductsHeroDescription</Trans>}
                MHeroVideo={MHeroVideo}
                THeroVideo={THeroVideo}
                DHeroVideo={DHeroVideo}
                scrollBtnStyles='lg:block'
                textWrapperClassList='pb-[16px]'
            />

            <CSHeadSpherePreview
                exterior={<Trans>CSHeadShowCaseExterior</Trans>}
                interior={<Trans>CSHeadShowCaseInterior</Trans>}
                heading1={<Trans>CSHeadShowcaseHeading1</Trans>}
                description1={<Trans>CSHeadShowcaseDescription1</Trans>}
                heading2={<Trans>CSHeadShowcaseHeading2</Trans>}
                description2={<Trans>CSHeadShowcaseDescription2</Trans>}
                id='csgimbalspherepreview'
            />
            <CsHeadShowcase
                heading1={<Trans>CSHeadBeforeAfterHeading1</Trans>}
                description1={<Trans>CSHeadBeforeAfterDescription1</Trans>}
                heading2={<Trans>CSHeadBeforeAfterHeading2</Trans>}
                description2={<Trans>CSHeadBeforeAfterDescription2</Trans>}
                id='CsHeadShowcase'
            />
            <SectionTextPictureImgFullH
                heading={<Trans>SectionTextPictureHeading</Trans>}
                content={<Trans>SectionTextPictureDescription</Trans>}
                imgSrc={Picture1}
                styleList='bg-black-100 text-white'
                imgAlt='Robot with gimbal and smartphone attached on black background' />

            <SectionBacgkround
                BGObject={BGObject}
                heading={<Trans>SectionBackgroundHeading</Trans>}
                description={<Trans>SectionBackgroundDescription</Trans>}
                fluidHeight={true}
            />


            <TilesSwiper2
                containerStyles='lg:pt-[140px]'
                heading='Features'
                SlideTiles={SlideTiles1}
                GridStyles='lg:grid-cols-4 grid-cols-3 auto-rows-fr gap-[16px]'
                TileStyle=''
            />
            <TilesSwiper2
                heading='Benefits'
                SlideTiles={SlideTiles2}
                GridStyles='lg:grid-cols-4 grid-cols-2 auto-rows-fr gap-[16px]'
                TileStyle=''
            />
            <TilesSwiper2
                heading='What’s in the package'
                SlideTiles={SlideTiles3}
                GridStyles='lg:grid-cols-6 grid-cols-3 auto-rows-fr gap-[16px]'
                TileStyle=''
            />

            {/* <SectionTechnology
                id='sectionTechnology'
                heading='Merging robotics with AI'
                content='The combination of Vumo hardware and AI-based software guarantees great looking, consistent stills and 360s of cars. Even outdoors in uneven terrain. In the competitive car business the quality and appeal of the customer experience matters the most. Vumo’s breakthrough Car Scanner robot enables you to bring car photography back in-house, optimize your human resources and improve your workflow. All while making your online listings stand out from the crowd.'
            /> */}
            <SectionOrder
                link='/contact'
                content={<Trans i18nKey='multiline' >Be at the top of the AI revolution in the car dealership industry. Contact our sales team to inquire about the price and delivery of your CS Gimbal.</Trans>}
                heading='Schedule a demo'
                linkText='Schedule a demo'
            />
            <SelectedProducts
                title={<Trans>SelectedProductsTitle</Trans>}
                end={<Trans>SelectedProductsEnd</Trans>}
                slug='/cs-gimbal'
            />
        </>
    )
}

export const Head = () => (
    <Seo
        title='CS Gimbal | Vumo.ai'
        description='Maximize space with CS Gimbal: handheld, professional camera, AI software for stunning car and interior shots. Effortless photography in compact spaces!'
    />
)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { language: { eq: $language }, ns: { eq: "cs_gimbal" } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`

export default csHead
